import { useState, useEffect } from 'react'

const DEFAULT_STEP_TIMING = {
    step2Delay: 1500,
    step3Delay: 1500,
}

export const useStepTimer = (config = {}) => {
    const {
        step2Delay,
        step3Delay,
        offer,
        hasOfferError
    } = { ...DEFAULT_STEP_TIMING, ...config }

    const [showStep2, setShowStep2] = useState(false)
    const [showStep3, setShowStep3] = useState(false)
    const [isOfferReady, setIsOfferReady] = useState(false)

    // Show Step 2 after delay
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowStep2(true)
        }, step2Delay)

        return () => clearTimeout(timer)
    }, [step2Delay])

    // Show Step 3 after Step 2 has been shown for specified delay
    useEffect(() => {
        if (showStep2 && !showStep3) {
            const timer = setTimeout(() => setShowStep3(true), step3Delay)
            return () => clearTimeout(timer)
        }
    }, [showStep2, showStep3, step3Delay])

    // Track when API call completes successfully
    useEffect(() => {
        if (offer && offer.offerId && !hasOfferError) {
            setIsOfferReady(true)
        }
    }, [offer, hasOfferError])

    return {
        showStep2,
        showStep3,
        isOfferReady
    }
}

export default useStepTimer
